import { render, staticRenderFns } from "./DamagedItems.vue?vue&type=template&id=10e1cc21&"
import script from "./DamagedItems.vue?vue&type=script&lang=js&"
export * from "./DamagedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports